module.exports = ":host {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column; }\n"